<div class="dns-zones">
  <div class="search">
    <app-search-field
      (searchText)="onSearch($event)"
      placeholder="Search domain. Use at least 3 characters."
    >
    </app-search-field>
  </div>

  <div class="table-container">
    <div class="header row">
      <h2>DNS Zones</h2>
      <div class="buttons row">
        <button matButton="filled" (click)="addDNSZone()">
          <fa-icon [icon]="['fas', 'plus']" size="lg"></fa-icon>
          Add DNS Zone
        </button>
        <button matButton="outlined" (click)="syncDNSZones()">
          <fa-icon [icon]="['fas', 'arrows-rotate']" size="lg"></fa-icon>
          Sync DNS Zones
        </button>
        <button matButton="outlined" (click)="syncDNSServer()">
          <fa-icon [icon]="['fas', 'arrows-rotate']" size="lg"></fa-icon>
          Sync DNS Server
        </button>
      </div>
    </div>

    @if (zones$ | async; as zones) {
      <mat-card appearance="outlined" class="dns-table-zones">
        <app-table
          #table
          [columns]="zonesColumns"
          [dataSource]="(zones$ | async) || []"
          [totalCount]="(totalCount$ | async) || 0"
          (pageChange)="handlePageEvent($event)"
        >
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>

            <td mat-cell *matCellDef="let element">
              @if (element.status) {
                <app-status-label [status]="toStatus(element.status)"></app-status-label>
              } @else {
                <span>-</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="buttons">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element">
              <div class="buttons">
                @if (element.status === dnsZoneStatus.DUPLICATE) {
                  <button
                    matRipple
                    class="icon-button activate"
                    matTooltip="Activate DNS Zone"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="activateDNSZone(element)"
                  >
                    <fa-icon [icon]="['fas', 'check']" size="lg"></fa-icon>
                  </button>
                }

                <button
                  matRipple
                  class="icon-button"
                  matTooltip="Edit DNS Zone"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  (click)="editDNSZone(element)"
                >
                  <fa-icon [icon]="['fas', 'pen']" size="lg"></fa-icon>
                </button>
                <button
                  matRipple
                  class="icon-button"
                  matTooltip="Delete DNS Zone"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  (click)="deleteDNSZone(element)"
                >
                  <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                </button>
              </div>
            </td>
          </ng-container>
        </app-table>
      </mat-card>
    }
  </div>
</div>
